// Action type constants for the Groups slice.
// Trimmed per docs/groups-migration/GROUPS-MIGRATION-PLAN.md decision D3 —
// the dormant .js version had 30 actions; 6 belonged to other features
// (group-moderation, the already-shipped Users "Groups" tab) and are dropped:
// GROUPS_LIST_FOR_MODERATION, ENTER_GROUP_TEXT_FOR_MODERATION,
// GET_GROUP_FOR_MODERATION, SEARCH_GROUP_FOR_MODERATION,
// ENTER_USER_GROUP_TEXT, SEARCH_USER_GROUP.
const actions = {
  SET_STATE: 'groups/SET_STATE',
  GROUPS_LIST: 'groups/GROUPS_LIST',
  ADD_GROUP: 'groups/ADD_GROUP',
  GET_GROUP: 'groups/GET_GROUP',
  UPDATE_GROUP: 'groups/UPDATE_GROUP',
  DELETE_GROUP: 'groups/DELETE_GROUP',
  SEARCH_GROUP: 'groups/SEARCH_GROUP',
  ENTER_GROUP_TEXT: 'groups/ENTER_GROUP_TEXT',
  GET_GROUP_MEMBERS: 'groups/GET_GROUP_MEMBERS',
  ENTER_GROUP_MEMBER_TEXT: 'groups/ENTER_GROUP_MEMBER_TEXT',
  SEARCH_GROUP_MEMBER: 'groups/SEARCH_GROUP_MEMBER',
  ADD_MEMBERS_TO_GROUP: 'groups/ADD_MEMBERS_TO_GROUP',
  NON_PARTICIPANTS_LIST: 'groups/NON_PARTICIPANTS_LIST',
  ENTER_NON_PARTICIPANT_TEXT: 'groups/ENTER_NON_PARTICIPANT_TEXT',
  SEARCH_NON_PARTICIPANT: 'groups/SEARCH_NON_PARTICIPANT',
  CHANGE_MEMBER_SCOPE: 'groups/CHANGE_MEMBER_SCOPE',
  GET_BANNED_GROUP_MEMBERS: 'groups/GET_BANNED_GROUP_MEMBERS',
  ENTER_BANNED_GROUP_MEMBER_TEXT: 'groups/ENTER_BANNED_GROUP_MEMBER_TEXT',
  SEARCH_BANNED_GROUP_MEMBER: 'groups/SEARCH_BANNED_GROUP_MEMBER',
  BAN_GROUP_MEMBER: 'groups/BAN_GROUP_MEMBER',
  UNBAN_GROUP_MEMBER: 'groups/UNBAN_GROUP_MEMBER',
  KICK_GROUP_MEMBER: 'groups/KICK_GROUP_MEMBER',
  GROUP_SCOPE_PERMISSIONS_LIST: 'groups/GROUP_SCOPE_PERMISSIONS_LIST',
  GROUP_SCOPE_PERMISSIONS_VALUES_GET: 'groups/GROUP_SCOPE_PERMISSIONS_VALUES_GET',
  GROUP_SCOPE_PERMISSIONS_UPDATE: 'groups/GROUP_SCOPE_PERMISSIONS_UPDATE',
  GROUP_SCOPE_PERMISSIONS_RESET: 'groups/GROUP_SCOPE_PERMISSIONS_RESET',
} as const

export default actions
